const ALLOWED_DOMAINS = [
  "emart.com",
  "emartapp.emart.com",
  "quickrefund.emart.com",
  "emile.emarteveryday.co.kr",
  "www.traders.co.kr"
];

const isAllowedExternalUrl = (parsed) =>
  ALLOWED_DOMAINS.some(
    (domain) =>
      parsed.hostname === domain || parsed.hostname.endsWith(`.${domain}`)
  );

export const validateExternalUrl = (url) => {
  try {
    const parsed = new URL(url);
    if (!["http:", "https:"].includes(parsed.protocol)) return false;
    return isAllowedExternalUrl(parsed);
  } catch {
    return false;
  }
};

export const getValidatedExternalUrl = (url) => {
  if (url == null || typeof url !== "string") return null;
  try {
    const parsed = new URL(url.trim());
    if (!["http:", "https:"].includes(parsed.protocol)) return null;
    return isAllowedExternalUrl(parsed) ? parsed.href : null;
  } catch {
    return null;
  }
};